import { render, staticRenderFns } from "./OSelectInput.vue?vue&type=template&id=5613e4c8&scoped=true"
import script from "./OSelectInput.vue?vue&type=script&lang=js"
export * from "./OSelectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5613e4c8",
  null
  
)

export default component.exports